import { Clientize } from 'types';
import { StandardHoldbackSelfService as StandardHoldbackServer } from 'types/StandardHoldbackSelfService';

export const HoldbackType = {
  standard: 'standard',
  domesticContent: 'domestic-content',
} as const;

export type HoldbackTypeValue = (typeof HoldbackType)[keyof typeof HoldbackType];

export type StandardHoldbackSelfServiceClientData = Clientize<StandardHoldbackServer>;
